var latestWinnersResultsTemplate = require('./latest-winners-search-results.handlebars');
var latestWinnersService = new latestWinnersService();
var Pager = require('./../../shared/components/pager/pagerService');
var latestWinnersPager = new Pager();
var urlParameter=require('./../../shared/scripts/UrlParameterHelper');
$(function () {

    if (!$('#latest-winners-search-results-container').length) return;

    //INITIALIZE
    let requestedPageSize = parseInt($('#latest-winners-pager-page-size').val());
    (Number.isInteger(requestedPageSize))
        ? latestWinnersPager.setPageSize(requestedPageSize)
        : latestWinnersPager.setPageSize(latestWinnersService.options.pageSize);

    //GET DATA
    latestWinnersPager.setCurrentPage(0);
    getLatestWinnersFilterValues();
    getLatestWinners();

    //EVENTS
    $('#latest-winners-apply-filters').on('click', function () {
        let $emptyResultMessage = $('#latest-winners-empty-result-message');
        let isValid = areLatestWinnersFiltersValid();
        if (isValid) {
            latestWinnersPager.setCurrentPage(0);
            getLatestWinnersFilterValues();
            getLatestWinners();
            $emptyResultMessage.addClass('hidden');
        } else {
            $emptyResultMessage.removeClass('hidden');
            $('#latest-winners-results').empty();
            $('#latest-winners-pager').addClass('hidden');
        }
    });

    $('#latest-winners-clear-filters').on('click', function () {
        let $emptyResultMessage = $('#latest-winners-empty-result-message');
        clearFilters();
        latestWinnersPager.setCurrentPage(0);
        getLatestWinnersFilterValues();
        getLatestWinners();
        $emptyResultMessage.addClass('hidden');
    });
});

function getLatestWinners() {
    latestWinnersService.options.pageSize = latestWinnersPager.getPageSize();
    latestWinnersService.options.page = latestWinnersPager.getCurrentPage();
    let itemId='';
    if (window.location.href.indexOf('?') > -1) {
        if(latestWinnersService.options.page>0 || latestWinnersService.options.keyword!=""|| (latestWinnersService.options.year !="0" && latestWinnersService.options.year !="" )){
            // console.log('push state called');
            history.pushState('', document.title, window.location.pathname);            
        }
        else{       
         itemId=urlParameter.getUrlParameterByName('itemId',window.location.search);
        }
    }
    latestWinnersService.options.QueryString=itemId;
    latestWinnersService.options.specificYear = getSpecificWinnerYear();
    latestWinnersService.options.specificWinner = getSpecificWinner();
/*    
console.log('latestWinnersService.options.page- '+latestWinnersService.options.page
+'\n-latestWinnersService.options.QueryString- '+latestWinnersService.options.QueryString
+'\n-latestWinnersService.options.keyword- '+latestWinnersService.options.keyword
+'\n-latestWinnersService.options.year- '+latestWinnersService.options.year);
*/
$.ajax({
        url: '/api/v1/latestwinners',
        type: 'POST',
        data: latestWinnersService.options,
        dataType: 'json'
    })
        .done(function (data) {

            var mapped = data.data.map((v, i, a) => {
                v.HasPrize = v.Prize === 0 ? false : true;

                return v;
            });

            var html = latestWinnersResultsTemplate({ latestWinners: mapped });
            $('#latest-winners-results').html(html);

            latestWinnersPager.update("latest-winners-pager", "#latest-winners-pager-container", getLatestWinners, data.totalPages, data.currentPage);
			/*---To get item id enabled on the accordian---*/
			
			try{			
				
				if(itemId!='')	{
                   // console.log('itemId after results loading- '+ itemId);
                  $("div[id*=title-latest-winner-"+itemId+"]").trigger('click');
				 /* try{
					  var id="#title-latest-winner-"+itemId;
					  console.log("generated id-"+id);
				  $(""+id+"").trigger('click');
				  }catch(err){console.log('error to trigger expander at latest winners'+ err.message);}
				 // $("#title-latest-winner-1b1842b7-9d65-4927-8b7f-eb20271026cf").trigger('click');
				 //#title-latest-winner-1B1842B7-9D65-4927-8B7F-EB20271026CF
				 */
                }
			}
			catch(error){console.log(error.message);}
			/*End new function*/
        });
}

function areLatestWinnersFiltersValid() {
    let keywordValue = $('#latest-winners-filter-keyword').val();
    let yearValue = $('#latest-winners-filter-year').val();

    return true;
}

function getSpecificWinner() {
    var segments = location.pathname.split('/');
    if (segments.length == 4) {
        return segments[3];
    }
}

function getSpecificWinnerYear() {
    var segments = location.pathname.split('/');
    if (segments.length == 4) {
        return parseInt(segments[2]);
    }
}

function clearFilters() {
    document.getElementById('latest-winners-filter-year').value = '0';
    $('#latest-winners-filter-keyword').val("");
}

function getLatestWinnersFilterValues() {
    let yearValue = $('#latest-winners-filter-year').val();
    let keywordValue = $('#latest-winners-filter-keyword').val();

    latestWinnersService.options.year = yearValue ? yearValue : "";
    latestWinnersService.options.keyword = keywordValue ? keywordValue : "";
}

function latestWinnersService(options) {
    var latestWinnersDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 12,
        keyword: "",
        year: "",
        specificYear: 0,
        specificWinner: '',
        QueryString: '',
    };

    this.options = $.extend(true, latestWinnersDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/latest-winners/latest-winners.js